import { Component } from '@inter-ikea-core/core';

/**
 * Same ID (25) as Cores UnserializableEntityComponent that is not yet exposed
 * to be used by us. When that is fixed that can be used instead and this can be removed
 */
export default class UnserializableEntityComponent implements Component {
  static id = 25;
  typeId = UnserializableEntityComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return true;
  }
}
